// store/modules/selectPage.js
export default {
    namespaced: true,
    state: {
        allPages: [],
        pageSelected: [],
        groups: [],
        listRetracted: false,
    },
    mutations: {
        updateSelectPageAllPages(state, newContent) {
            state.allPages = newContent;
        },
        updateSelectPagePageSelected(state, newContent) {
            state.pageSelected = newContent;
        },
        updateSelectPageGroups(state, newContent) {
            state.groups = newContent;
        },
        updateSelectPageListRetracted(state, newContent) {
            state.listRetracted = newContent;
        },
    },
    getters: {
        selectPageAllPages(state) {
            return state.allPages;
        },
        selectPagePageSelected(state) {
            return state.pageSelected;
        },
        selectPageGroups(state) {
            return state.groups;
        },
        selectPageStateListRetracted(state) {
            return state.listRetracted;
        },
    },
};
